import { useSyncExternalStore, type ReactNode } from 'react'

const emptySubscribe = () => () => {}

/**
 * Renders `children` only on the client. During SSR and the initial hydration
 * render it renders `fallback` (default `null`); `useSyncExternalStore` then
 * re-renders with `children` synchronously before the browser paints, so there
 * is no visible flash and no hydration mismatch.
 */
export function ClientOnly({
  children,
  fallback = null,
}: {
  children: ReactNode
  fallback?: ReactNode
}) {
  const isClient = useSyncExternalStore(
    emptySubscribe,
    () => true,
    () => false,
  )

  return isClient ? <>{children}</> : <>{fallback}</>
}
